import React, { ReactNode } from "react";

interface ModalType {
  children?: ReactNode;
  isOpen: boolean;
  toggle: () => void;
  id: string;
}

export default function Modal(props: ModalType) {
  return (
    <>
      {props.id === "config-label-modal" ? (props.isOpen && (
        <div className="config-label-modal-overlay" onClick={props.toggle}>
          <div onClick={(e) => e.stopPropagation()} className="config-label-modal-box hoverable">
            {props.children}
          </div>
        </div>
      )):(
        props.isOpen && (
        <div className="compare-research-modal-overlay" onClick={props.toggle}>
          <div onClick={(e) => e.stopPropagation()} className="compare-research-modal-box hoverable">
            {props.children}
          </div>
        </div>)
      )
    }
    </>
  );
}
